import { io, Socket } from 'socket.io-client';

const devURL = import.meta.env.VITE_SOCKETS_URL || 'https://dev.coins-sport.com';
const prodURL = import.meta.env.VITE_SOCKETS_URL || 'https://coins-sport.com';

const URL = process.env.NODE_ENV === 'production' ? prodURL : devURL;
// const URL = prodURL;

export let socket: Socket | undefined;

export const socketInit = (defaultHandler: (...args: any[]) => void) => {
  socket = io(URL, { transports: ['websocket'], withCredentials: true });

  socket.on('connect', () => {
    if (socket?.recovered) {
      console.log('Socket connection recovered.');
    }
    socket && socket.emit('join', import.meta.env.VITE_SOCKET_SERVICE_ROOM);
  });
  socket.onAny(defaultHandler);
};
